<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="onCloseModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">
        {{ "add_custom_code" | translate }}
    </h4>
</div>
<div class="modal-body">
    <p class="mb-20">
        {{ "custom_code_use_tags" | translate }}
        <br />
        {{ "custom_code_hint" | translate }}
        <br />
        {{ "custom_code_noty" | translate }}
    </p>

    <div class="form-group">
        <textarea
            class="form-control"
            rows="5"
            placeholder="<script> ... </script>"
            [formControl]="contentControl"
        ></textarea>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="onCancel()">
        {{ "cancel" | translate }}
    </button>
    <button type="button" class="btn btn-success" (click)="onConfirm()">
        {{ "add" | translate }}
    </button>
</div>
